export const SITE_DATA_FETCH_REQUEST = "SITE_DATA_FETCH_REQUEST";
export const SITE_DATA_FETCH_SUCCESS = "SITE_DATA_FETCH_SUCCESS";
export const SITE_DATA_FETCH_ERROR = "SITE_DATA_FETCH_ERROR";
